module.exports = __webpack_public_path__ + "static/media/Logo_3.52d3be70.png";